import { Widget } from '../../../../../../../providers/bridge-api/dashboard.service';
import { FieldService } from '../../../../../../../providers/storage-api/field.service';
import { Utils } from '../../../../../../../utils/utils';
import { WidgetChartOptions } from '../../../../widget-chart/widget-chart.component';
import { AiSummaryTranslocoParameters } from './widget-ai-insights-summary.service';

export default class ScatterPlotSummaryParameters implements AiSummaryTranslocoParameters {
  assembleParameters(selectedPoints: any[], widget: Widget<WidgetChartOptions>) {
    return selectedPoints
      .flatMap((p) => p)
      .map((p, idx) => {
        let translationKey = `widgets.ai-insights.summary.${widget.payload.type}`;
        switch (widget.payload.xAxis) {
          case 'sentiment':
          case 'volume':
          case 'frequency':
          case 'impact_positive':
          case 'impact_negative':
            translationKey += `.${widget.payload.xAxis}`;
            break;
          default:
            translationKey += `.metadata`;
            break;
        }
        translationKey = `${translationKey}.${idx === 0 ? 'first-point' : 'rest-of-points'}`;

        return {
          translationKey,
          translationParams: {
            fieldValue: p.series.name,
            fieldName: FieldService.getFieldLongName(widget.payload.xAxis),
            score: Utils.round(p.x, 2),
          },
        };
      });
  }
}
